import { render, staticRenderFns } from "./ViSpinner.vue?vue&type=template&id=41b1f934"
import script from "./ViSpinner.vue?vue&type=script&lang=js"
export * from "./ViSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports